exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar-logo-container[data-v-2bcb8382]{position:relative;width:100%;height:60px;line-height:60px;background:#fff;text-align:center;overflow:hidden;border-bottom:1px solid #031e39}.sidebar-logo-container .sidebar-logo-link[data-v-2bcb8382]{height:100%;width:100%}.sidebar-logo-container .sidebar-logo-link .sidebar-logo[data-v-2bcb8382]{width:100%;margin-top:6px}", ""]);

// exports
